import * as React from "react";
import { FormControlLabel, styled, Switch } from "@mui/material";
import { useTranslate } from "../../../hooks/useTranslate";
import { PatientColorMap } from "../../../layout/patientColorMap";
import clsx from "clsx";

//region [[ Styles ]]

const DeniedToggleView = styled(FormControlLabel)({
  flex: "2",
  "& .patient-Mui-checked": {
    color: PatientColorMap.Primary,
  },
  "& .patient-Mui-checked + .patient-MuiSwitch-track": {
    backgroundColor: PatientColorMap.Primary,
  },
  "& .patient-MuiFormControlLabel-label": {
    fontSize: "12px",
    fontWeight: 700,
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface DeniedToggleProps {
  className?: string;
  diseaseName: string;
  checked: boolean;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const DeniedToggle = ({ diseaseName, ...props }: DeniedToggleProps) => {
  const { translate } = useTranslate();

  const label =
    translate("SHOWING") +
    " " +
    (props.checked
      ? translate("WHEN_DENIED")
          .split("#DISEASE_NAME#")
          .join(diseaseName)
      : translate("WHEN_APPROVED")
          .split("#DISEASE_NAME#")
          .join(diseaseName));

  return (
    <DeniedToggleView
      className={clsx(props.className)}
      control={<Switch checked={props.checked} onChange={props.onChange} />}
      label={label}
    />
  );
};
